<lms-dynamic-form
  #keplerForm
  [action]="keplerMatch ? 'kepler.edit' : 'kepler.create'"
  [questionsService]="keplerDataQuestionsService"
  [data]="data"
  [options]="{
    submitLabel: keplerMatch ? 'kepler.saveMatch' : 'kepler.addMatch',
    disableCard: true,
    hideSubmit: false
  }"
  (submit)="onSubmit($event)"
>
  <ng-content select="[form-actions-before]" form-actions-before></ng-content>
</lms-dynamic-form>
<lms-translation-modal #translationModal (confirmTranslation)="confirmTranslation($event)"> </lms-translation-modal>
